import * as PermissionActions from '../types/permissionTypes';
import { PermissionType } from 'redux/types/storeTypes';

const initialState: PermissionType = {
  loading: false,
  error: undefined,
  items: []
};

const permissionReducer = (state = initialState, action: { [key: string]: any }) => {

  switch (action.type) {

     case PermissionActions.GET_PERMISSIONS_START:
      return {
        ...state,
        error: undefined,
        loading: true,
      };

    case PermissionActions.GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        items: action.payload.permissions,
        loading: false,
      };

    case PermissionActions.GET_PERMISSIONS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
};

export default permissionReducer;
